import { render, staticRenderFns } from "./PregnancyTerm.vue?vue&type=template&id=997a02e4"
import script from "./PregnancyTerm.vue?vue&type=script&lang=js"
export * from "./PregnancyTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports